import { useEffect } from "react";

import { getSearch } from "@/api/endpoints/searches";
import { SEARCH_KIND } from "@/constants";
import Container from "@components/Container";
import Spinner from "@components/Spinner";
import Typography from "@components/Typography";

import styles from "./Initializing.module.css";

const Initializing = ({ alert }) => {
  useEffect(() => {
    let mounted = true;

    if (alert.uuid) {
      (async function () {
        while (mounted) {
          try {
            const { data } = await getSearch(alert.uuid);

            if (data.is_initializing === false) {
              window.location.reload();
            }
          } catch {
            // reload page if the search creation fails
            window.location.reload();
          }
          await new Promise((resolve) => setTimeout(resolve, 10000)); // 10 seconds
        }
      })();
    }
    return () => {
      mounted = false;
    };
  }, [alert.uuid]);

  const isSavedSearch = alert && alert.kind === SEARCH_KIND.SAVED;

  return alert ? (
    <Container
      fullWidth
      className={styles.loadingMentions}
      data-testid="alert-initializing"
    >
      <div className={styles.spinner}>
        <Spinner />
      </div>
      <Typography variant="subtitle-1" margin="none" align="center">
        {isSavedSearch
          ? L.SAVED_SEARCH_MENTIONS_INITIALIZING
          : L.MENTIONS_INITIALIZING}
      </Typography>

      <Typography align="center">
        {isSavedSearch
          ? L.SAVED_SEARCH_MENTIONS_INITIALIZING_CREATING
          : L.MENTIONS_INITIALIZING_CREATING}
      </Typography>
    </Container>
  ) : null;
};
export default Initializing;
